import { API_BASE_URL, API_PATHS,getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class ClassTeacherService {



static getclassteacher(item) {
     const user = JSON.parse(localStorage.getItem("user"));
  const dynamicPaths = getApiPaths(user?.data?.roleId?.name);
  let api = `${API_BASE_URL}${dynamicPaths.getclassTeacher}`;
   const params = new URLSearchParams();
    if(item?.id) params.append("id", item.id);
     if(item?.teacherId) params.append("teacherId", item.teacherId);
    if ([...params].length > 0) {
    api += `?${params.toString()}`;
  }
    return axiosInstance
        .get(api,item)
}

static addclassteacher(data) {
  let api = '';
    api = `${API_BASE_URL}${API_PATHS.addclassteacher}`;
    return axiosInstance
        .post(api,data)

}

static editclassteacher(data) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editclassTeacher}`;
    return axiosInstance
        .put(api,data)
        
}
 
static deleteclassteacher(id) {
  let api = '';

        api = `${API_BASE_URL}${API_PATHS.deleteclassTeacher}?id=${id}`;
    
    return axiosInstance
        .delete(api)
}


}

export default ClassTeacherService;
